<app-alert-messages *ngIf="bResponseAlert" [resMessage]="resMessage"></app-alert-messages>
<div class="modal-header d-flex justify-content-between align-items-center">
  <div>

    <h4 class="modal-title" id="modal-basic-title">Execute Workflow({{file.name}})</h4>
  </div>
  <div class="d-flex align-items-center">
    <!-- <button type="button" class="btn btn-outline-secondary me-2 btn-sm" (click)="dismissModal()">Cancel</button> -->
    <!-- <button type="submit" class="btn btn-primary me-2 btn-sm" (click)="openEditWorkflowModal(schemaWorkflow)"> <i class="fas fa-pen me-1"></i>Edit Workflow</button> -->
    <button type="submit" class="btn btn-primary me-2 btn-sm" (click)="onSubmit()">
      <i class="fas fa-play me-1"></i> Execute
    </button>
    <div *ngIf="!file.fileName" class="mode-toggle toggle-option2 p-1" 
    (click)="openEditWorkflowModal(schemaWorkflow)">
    <span class="font-11 fw-normal"> <i class="fa-solid fa-pencil me-1 mr-2"></i> Edit</span>
  </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
  </div>
</div>
<div *ngIf="!noSchemaToShow && !bLoading" class="modal-body p-0" style="height: calc(100vh - 120px);overflow: auto;">
  <div class="workflow-container">
    <!-- <div class="text-end" *ngIf="!file?.isDirectory">
      <button class="btn btn-primary btn-sm" (click)="skipExecuteAll()">Skip Execute for All Activities</button>
    </div> -->
    <h2 *ngIf="workflowData?.title">{{ workflowData.title }}</h2>
    <div class="top-card ">
      <div class="d-flex align-items-center">
        <button class="btn btn-outline-secondary btn-sm me-4 fw-bold" (click)="skipExecuteAll()">Set “Skip Execute” for All</button>
        <div *ngIf="file?.isDirectory" class="d-flex  align-items-center">
          <div class="me-3 mt-1" *ngFor="let switchItem of switches">
            <div class="form-check grid-view-checkbox d-flex align-items-center ps-0">
              <input type="checkbox" class="form-check-input" [id]="switchItem.key" [(ngModel)]="switchItem.value"
                (change)="updateSwitchValue(switchItem.key, switchItem.value)">
              <label [for]="switchItem.key" class="form-check-label ml-2">
                <strong>{{ switchItem.label }}</strong>
              </label>
            </div>
          </div>
          <div class="ms-3">
            <div class="form-group d-flex align-items-center gap-3">
              <label class="form-label font-12 mb-0"><strong>Number of Concurrent Tasks:</strong></label>
              <input class="form-control" type="number" value="0" [(ngModel)]="numberOfConcurrentTasks" max="100"
                 (keypress)="validateInput($event)">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="workflow-container pt-0">
    <form [formGroup]="workflowForm">
      <div class="activities-grid">
        <div *ngFor="let activity of workflowData?.enabledActivitiesCopy" class="activity-card"
          [ngClass]="activity.name == selectedActivity ? 'selected-activity' : ''" (click)="selectActivity(activity)">
          <div class="card-header">
            <h3>{{ activity.title }}</h3>
          </div>

          <div class="card-content">
            <small *ngIf="hasError(activity.name + '_enabled')" class="error-message">
              {{ getErrorMessage(activity.name + '_enabled') }}
            </small>
            <!-- <div class="badges">
              <span *ngIf="activity.required" class="required-badge">Required</span>
            </div> -->
            <!-- EXECUTION SWITCHES -->
            <div class="schema-radio d-flex flex-column">
              <label class="custom-radio">
                <input type="radio" [name]="activity.name + '_execute'" [value]="'ifNeeded'"
                  [formControlName]="activity.name + '_execute'">
                <span class="p-0 font-13">Execute (If Needed)</span>
              </label>
              <label class="custom-radio">
                <input type="radio" [name]="activity.name + '_execute'" [value]="'force'"
                  [formControlName]="activity.name + '_execute'">
                <span class="p-0 font-13">Force Execute</span>
              </label>
              <label class="custom-radio">
                <input type="radio" [name]="activity.name + '_execute'" [value]="'skip'"
                  [formControlName]="activity.name + '_execute'">
                <span class="p-0 font-13">Skip Execute</span>
              </label>
            </div>

            <div class="properties-section" style="margin-bottom: 20px;"
              *ngIf="hasProperties(activity) && isActivityEnabled(activity.name) && activity.name != 'searchQA'">
                  <div *ngFor="let prop of activity.properties" class="property-item-show mb-1">
                    <!-- Display for enum properties -->
                      <p class="mb-0" *ngIf="isEnumProperty(prop)">
                        <strong>{{ getEnumDisplayName(activity.name,prop) }}</strong>
                      </p>
                    <!-- Display for boolean properties -->
                      <p class=" d-flex align-items-center justify-content-between mb-0" *ngIf="isBooleanProperty(prop)">
                        <strong>{{ prop.displayName }}:</strong>
                        <span class="status-box" [class.active]="getFormValue(activity.name, prop)">
                          {{ getFormValue(activity.name, prop) ? '✓' : '✗' }}
                        </span>
                      </p>
                    <!-- Display for string properties -->
                    <p class="mb-0" *ngIf="isStringProperty(prop)">
                      <strong> {{ prop.displayName }}:</strong>
                      <span 
                        class="funcName-word cursor-pointer"
                        [ngbTooltip]="getFormValue(activity.name, prop)" 
                        container="body">
                        {{ (getFormValue(activity.name, prop) | slice:0:100) + (getFormValue(activity.name, prop)?.length > 100 ? '...' : '') || 'N/A' }}
                      </span>
                    </p>
                  </div>
               </div>
          </div>

          <div class="text-end" style="position: absolute; right: 15px; bottom: 5px;">
            <i class="fa-regular fa-circle-info cursor-pointer info-icon"
                [ngbTooltip]="activity.description" container="body">
            </i>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div *ngIf="bLoading" class="d-flex justify-content-center p-4  align-items-center loader-position ">
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div *ngIf="noSchemaToShow && !bLoading" class="d-flex align-items-center justify-content-center p-4">
  <small class="heading">No WorkFlow Found!</small>
</div>

<ng-template #schemaWorkflow let-modal>
  <app-schema-workflow [file]="file" [schemaProperty]="false" [WorkflowType]="WorkflowType"  [selectedFolder]="selectedFolder"></app-schema-workflow>
</ng-template>